module.exports = __webpack_public_path__ + "static/media/yetibookdemostefwong.b5df6dcf.mov";